import React from 'react'; // eslint-disable-line
import reactCSS from 'reactcss';
import { ChromePicker } from 'react-color';
import hexRgb from 'hex-rgb';
import i18n from '../../i18n';
import Reset from '../svg/Reset';

class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            displayName: this.props.name,
            pickerIndex: this.props.csIndex,
            displayColorPicker: false,
            color: {
                hex: this.props.hex,
                r: 0,
                g: 0,
                b: 0,
                a: 1,
            },
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.hex === prevState.color.hex && this.props.hex !== prevProps.hex) {
            this.setColorForPicker(this.props);
        }
    }

    handleReset = () => {
        this.props.saveCustomColors(this.state.pickerIndex, this.props.reset);
    }

    setColorForPicker = (nextProps) => {
        this.setState({
            color: {
                hex: nextProps.hex,
                r: 0,
                g: 0,
                b: 0,
                a: 1,
            },
        });
    }

    handleClick = () => {
        this.setState((prevState) => {
            return { displayColorPicker: !prevState.displayColorPicker };
        });
    };

    handleClose = () => {
        this.props.saveCustomColors(this.state.pickerIndex, this.state.color.hex);
        this.setState({ displayColorPicker: false });
    };

    handleChange = (color) => {
        this.setState({ color: color.rgb });
        this.setState({ color: { hex: color.hex } });
    };

    getRGBValues = (hex, i) => {
        const stringHex = `${hex}`;
        const rgb = hexRgb(stringHex);
        return rgb[i];
    }

    render() {
        const styles = reactCSS({
            default: {
                color: {
                    borderColor: `rgba(${this.getRGBValues(this.state.color.hex, 0)}, ${this.getRGBValues(this.state.color.hex, 1)}, ${this.getRGBValues(this.state.color.hex, 2)}, 1)`,
                    background: `rgba(${this.getRGBValues(this.state.color.hex, 0)}, ${this.getRGBValues(this.state.color.hex, 1)}, ${this.getRGBValues(this.state.color.hex, 2)}, 1)`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                    top: '35px',
                    right: '1px',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });

        return (
            <div
                data-qa={this.props.containerId}
                id={this.props.containerId}
                className="design-setting"
            >
                <h3 data-qa={`${this.props.containerId}-header`}>{this.state.displayName}</h3>
                <Reset dataqa={`${this.props.containerId}-reset-icon`} reset={this.handleReset} />
                {/* eslint-disable-next-line */}
                <h3
                    data-qa={`${this.props.containerId}-reset-text`}
                    className="reset-color"
                    onClick={this.handleReset}
                >
                    {i18n.t('reset')}
                </h3>
                <div
                    data-qa={`${this.props.containerId}-picker`}
                    className="color-choice-and-picker"
                    style={{ position: 'relative' }}
                >
                    <div className="color-hex" data-qa={`${this.props.containerId}-color-hex`}>
                        {this.state.color.hex}
                    </div>

                    {/* eslint-disable-next-line */}
                    <div
                        className="color-choice-wrap"
                        onClick={this.handleClick}
                        data-qa={`${this.props.containerId}-color-choice-wrap`}
                    >
                        <div
                            className="color-choice"
                            style={styles.color}
                            data-qa={`${this.props.containerId}-color-choice`}
                        />
                    </div>

                    {this.state.displayColorPicker ? (
                        <div
                            style={styles.popover}
                            data-qa={`${this.props.containerId}-display-picker`}
                        >
                            {/* eslint-disable-next-line */}
                            <div
                                style={styles.cover}
                                onClick={this.handleClose}
                                data-qa={`${this.props.containerId}-close`}
                            />
                            <ChromePicker
                                color={this.state.color}
                                onChange={this.handleChange}
                                disableAlpha
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default ColorPicker;
